import React from 'react'

import './css/Notification.css'

export default props => {
  return (
    <div className="Notification-wrap">
      <div className="notification animated zoomIn">
        <button className="delete" onClick={props.hide}></button>
        {props.text}
      </div>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/Notification.js
 **/